import { useSearchParam } from "lib/@hooks/use-search-param"
import { AdvancedFilterChanged, FilterSchedule, RefreshScheduleSelector } from "event-definitions"
import { useEffectOnSubsequentChange } from "lib/@hooks/use-effect-on-subsequent-change"
import { SearchBoxUsingSearchParam } from "lib/@components/searchBoxUsingSearchParam"

export function FilterView({ sx }) {
    let [search] = useSearchParam("search", "")
    search = search.toLowerCase()
    FilterSchedule.useEvent(filter, [search])
    useEffectOnSubsequentChange(() => {
        console.log("Search changed", search)
        AdvancedFilterChanged.raiseOnce()
        RefreshScheduleSelector.raiseOnce()
    }, [search])
    return <SearchBoxUsingSearchParam placeholder="Filter..." sx={sx} />

    function filter({ items }) {
        return {
            items: items
                .filter(Boolean)
                .filter(
                    (item) => item.label?.toLowerCase().includes(search) || item.code?.toLowerCase().startsWith(search)
                ),
        }
    }
}
